import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

export function slugify(value: string): string {
	return value
		.normalize('NFD')
		.replaceAll(/\p{Diacritic}/gu, '')
		.replaceAll(/([a-z0-9])([A-Z])/g, '$1-$2')
		.toLowerCase()
		.replaceAll(/[^a-z0-9]+/g, '-')
		.replaceAll(/^-+|-+$/g, '');
}

@Pipe({
	name: 'slugify',
	pure: true,
})
export class SlugifyPipe implements PipeTransform {
	transform(value: string): string {
		return slugify(value);
	}
}
